import { z } from 'zod';

export enum CallAction {
  Answered = 'answered',
  Missed = 'missed',
}

const callActionSchema = z.nativeEnum(CallAction);

const ringCentralCallSchema = z.object({
  id: z.number(),
  business_id: z.number(),
  action: callActionSchema,
  status: z.string().nullable(),
  direction: z.literal('inbound').or(z.literal('outbound')),
  duration: z.number(),
  to: z.string(),
  from: z.string(),
  time: z.number(),
});

export type RingCentralCall = z.infer<typeof ringCentralCallSchema>;

const ringCentralCallTableSchema = z.array(
  z
    .object({
      date: z.number(),
      callMade: z.boolean(),
      introMade: z.boolean(),
      memberMade: z.boolean(),
    })
    .merge(ringCentralCallSchema),
);

export type RingCentralCallTable = z.infer<typeof ringCentralCallTableSchema>;

export const ringCentralLeadSchema = z.object({
  id: z.number(),
  phone: z.string(),
  name: z.string(),
  email: z.string(),
  leadDate: z.number(),
  followed: z.boolean(),
  schedule: z.array(z.number()),
  table: ringCentralCallTableSchema,
  calls: z.array(ringCentralCallSchema),
  leadToCall: z.string(),
  totalCalls: z.number(),
  inboundCalls: z.number(),
  outboundCalls: z.number(),
  nextContactDate: z.number().nullable(),
  callMade: z.boolean(),
  introMade: z.boolean(),
  introDate: z.number().nullable(),
  memberMade: z.boolean(),
  memberDate: z.number().nullable(),
});

export type RingCentralLead = z.infer<typeof ringCentralLeadSchema>;

const callSOPOptionsSchema = z
  .literal('call')
  .or(z.literal('text'))
  .or(z.literal('email'));
const callSOPSchema = z.object({
  type: z.array(callSOPOptionsSchema),
  daysAfter: z.number(),
});

export type CallSOP = z.infer<typeof callSOPSchema>;

const ringCentralRulesSchema = z.object({
  helpers: z.array(z.string()),
  problems: z.array(z.string()),
});

export type RingCentralRules = z.infer<typeof ringCentralRulesSchema>;

export const ringCentralDataSchema = z.object({
  rules: ringCentralRulesSchema,
  result: z.array(ringCentralLeadSchema),
  sop: z.array(callSOPSchema),
});

export type RingCentralData = z.infer<typeof ringCentralDataSchema>;
